<script setup>
import {computed, onMounted, ref, watch} from "vue";
import {useRoute, useRouter} from "vue-router"
import NavHeader from './components/global/Nav.vue'
import Modal from "./components/Modal.vue";
import {useModalStore} from "./store/modal.js";
import {useAuthStore} from "./store/auth.js";
import Toastr from "./components/global/Toastr.vue";

const modalStore = useModalStore();
const route = useRoute()
const router = useRouter()
const authStore = useAuthStore();

const routerReady = ref(false)
router.isReady().then(() => { routerReady.value = true })

const isAuthenticated = computed(() => {
    return routerReady.value && !route.path.includes('auth') && !route.path.includes('monitoring')
})

const setTheme = (theme) => {
    document.documentElement.classList.remove("light", "dark");
    if (theme) {
        document.documentElement.classList.add(theme);
    }
}
watch(() => authStore.theme, (theme) => {
    setTheme(theme)
})

onMounted(() => {
    setTheme(authStore.theme)
})
</script>

<template>
    <toastr />
    <nav-header v-if="isAuthenticated" />
    <router-view />
    <modal v-if="modalStore.active_modal"/>
</template>
